export default {
  methods: {
    notifyError(message, title = 'An error has occurred') {
      this.$vs.notify({
        color: 'danger',
        title: title,
        text: message,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        position: 'top-right'
      });
    },
    notifyWarning(message, title = 'Warning') {
      this.$vs.notify({
        color: 'warning',
        title: title,
        text: message,
        iconPack: 'feather',
        position: 'top-right'
      });
    },
    notifySuccess(message, title = 'Success') {
      this.$vs.notify({
        color: 'success',
        title: title,
        text: message,
        iconPack: 'feather',
        position: 'top-right'
      });
    },
    notifyMissingFields(title = 'An error has occurred') {
      this.$vs.notify({
        color: 'danger',
        title: title,
        text: 'Not all required fields have been provided',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        position: 'top-right'
      });
    }
  },
};
